import React from 'react';
import { FooterOrganism, AffiliationDispenseOrganism, Slider, ElementCard } from '../../Organisms';
import { Text, Button } from '../../Atoms';
import { blue, green, pink, red } from '../../Config/Config'
function TemplateActuality(props) {

    const renderElementCard = (color) => {
        return (
            <ElementCard
                classNameElementContainer='actuality-element-container'
                borderColor={color}
                cardContent={
                    <div className="actuality-content-container">
                        <Text text="SPVIE Santé Famille+, la première complémentaire santé qui couvre vos parents et beaux-parents !" className="actuality-content-title" />
                        <Text text="Parce que nous savons que protéger l’ensemble de votre famille est essentiel, nous avons créé une offre unique pour répondre au besoin de 2,7 millions de français : s’assurer de la sécurité de ses parents et beaux-parents." className="actuality-content-text actuality-content-first-text" />
                        <Text text="Casser les codes de l’assurance, telle a toujours été la devise de SPVIE Assurances. Fidèle à ses engagements, SPVIE Assurances révolutionne la complémentaire santé et propose un contrat permettant d’affilier ses ascendants au même titre que ses enfants." className="actuality-content-text actuality-content-second-text" />
                        <div className="actuality-content-button-container">
                            <Button text="Lire l’article" className="actuality-content-button" style={{ backgroundColor: `${color}` }} />
                        </div>
                    </div>
                }
            />
        )
    }
    return (
        <div className="template-scroll actuality-container">
            <Text text="Actualités" className="actuality-title" />
            <div className="actuality-slider-container">
                <Slider
                    classNameSliderContainer="actuality-slider"
                    elementNumber={4}
                    contentNumber={window.innerWidth > 768 ? 2 : 1}
                    dotClicked={null}
                    classNameContentContainer='actuality-slider-content-container'
                    element={[
                        renderElementCard(pink),
                        renderElementCard(red),
                        renderElementCard(blue),
                        renderElementCard(green),
                    ]}
                />
            </div>
        </div>
    );
}

export default TemplateActuality;
